/* eslint-disable import/prefer-default-export */
import { callApi } from 'utils'

/**
 *
 * @param {Object} values
 * @param {boolean} paymentStatus
 */

 const BASE_URL = process.env.REACT_APP_BASE_URL;
 
export async function createAppointment(values, paymentStatus) {
  const formData = new FormData()

  console.log(values)
  const url = BASE_URL + '/api/appointments'

  formData.append('name', values.name)
  formData.append('mobile', values.mobile)
  formData.append('email', values.email)
  // 5dde62f47aa0be4ac82bfb2b dept
  // 5dde63377aa0be4ac82bfb2d doc
  // formData.append('speciality', values.speciality)
  formData.append('speciality', values.speciality)
  formData.append('doctor', values.doctor)
  formData.append('dateAppointment', values.dateAppointment)
  formData.append('gender', values.gender)
  formData.append('age', values.age)
  formData.append('address', values.address || '')
  formData.append('hospitalNo', values.hospitalNo || '')
  formData.append('country', values.country || '')
  formData.append('state', values.state || '')
  formData.append('city', values.city || '')
  formData.append('pincode', values.pincode || '')
  formData.append('referringPhysician', values.referringPhysician || '')
  formData.append('medicalHistory', values.medicalHistory || '')
  formData.append('paymentStatus', paymentStatus ? 'authorized' : 'created')
  // const files = [...values.reports]
  if (values.reports && values.reports.length > 0) values.reports.map(i => formData.append('report', i))

  try {
    const json = await callApi(url, { method: 'POST', body: formData })
    if (json) return json
    throw new Error()
  } catch (error) {
    console.log('error')
    throw error;
  }
  
}
